import { useEffect } from 'react'
import { getFirestore, doc, getDoc } from 'firebase/firestore'
import { getAuth, onAuthStateChanged, User } from 'firebase/auth'

import { app } from 'src/configuration-firebase'

import { useAppDispatch } from 'src/hooks/useAppDispatch'

import {
  clearUser,
  loginSuccess,
} from 'src/store/reducers/AuthReducer/AuthSlice'

const auth = getAuth(app)
const db = getFirestore(app)

const useAuthListener = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(
      auth,
      async (authUser: User | null) => {
        if (authUser) {
          const userRef = doc(db, 'users', authUser.uid)
          const userSnap = await getDoc(userRef)

          if (userSnap.exists()) {
            dispatch(loginSuccess({ uid: authUser.uid, ...userSnap.data() }))
          } else {
            dispatch(loginSuccess(authUser))
          }
        } else {
          dispatch(clearUser())
        }
      },
    )

    return () => unsubscribe()
  }, [dispatch])
}

export default useAuthListener
